import request from '@/utils/request'
// import qs from 'qs'

// 分页查看详情
export const infoList = (getData) => {
  return request({
    url: '/back/item/pageList',
    method: 'get',
    headers: {
      'content-type': 'application/json'
    },
    // data: postData
    params: getData
  })
}
// 根据id查询
export const getById = (getData) => {
  return request({
    url: '/back/item/getById',
    method: 'get',
    headers: {
      'content-type': 'application/json'
    },
    params: getData
  })
}
// 删除详情
export const deleteInfo = (getData) => {
  return request({
    url: '/back/item/deleteById',
    method: 'get',
    headers: {
      'content-type': 'application/json'
    },
    params: getData
  })
}
// 修改详情
export const updateInfo = (postData) => {
  return request({
    url: '/back/item/update',
    method: 'post',
    headers: {
      'content-type': 'application/json'
    },
    data: postData
  })
}

// 新增详情
export const addInfo = (postData) => {
  return request({
    url: '/back/item/save',
    method: 'post',
    headers: {
      'content-type': 'application/json'
    },
    data: postData
  })
}
